import clsx from 'clsx';

// Types
import type { HashtagType } from '@/utils/hooks/swr/useHashtags';

type HashtagsItemProps = {
    item: HashtagType;
    className?: string;
};

const HashtagsItem = ({ item, className }: HashtagsItemProps) => {
    return (
        <div className={clsx('overflow-hidden', className)}>
            <p className="overflow-hidden text-ellipsis whitespace-nowrap font-GSemiBold text-sm">
                #{item?.name}
            </p>
        </div>
    );
};

export default HashtagsItem;
